// extracted by mini-css-extract-plugin
export var actions = "_z-0";
export var actionsContainer = "_z-6";
export var border = "_z-1";
export var childFullHeight = "_z-d";
export var collapse = "_z-2";
export var content = "_z-8";
export var contentChild = "_z-c";
export var fullscreen = "_z-a";
export var headerContainer = "_z-3";
export var headerRow = "_z-5";
export var hidePadding = "_z-9";
export var noScrollX = "_z-e";
export var noScrollY = "_z-f";
export var optOutTopPadding = "_z-b";
export var pagePadding = "_z-7";
export var profile = "_z-g";
export var profileContainer = "_z-h";
export var profileImage = "_z-i";
export var profileMain = "_z-j";
export var profileSubtitle = "_z-l";
export var profileTitle = "_z-k";
export var tabsWrapper = "_z-4";
export var title = "_z-m";